import { v4 as uuidv4 } from 'uuid';
import { __ } from "./Translate";
import TranslationsContext from "./TranslationsContext";
export default function MappingRow({ index, airtableField, wordPressField, fieldOptions, mappingManager, ...props }) {
	const { removeMappingRow, airtableFieldsOptions, wordPressFieldsOptions, updateAirtableField, updateWordPressField, updateFieldOption, getWordPressFieldById } = mappingManager;
	const airtableFieldDisabled = airtableFieldsOptions.length === 0; // || loadingDatabasesAndPages;
	let wordPressFieldConfig = {};
	if (wordPressField) {
		wordPressFieldConfig = getWordPressFieldById(wordPressField) ?? {};
	}
	const airtableFieldChangedHandler = (e) => {
		updateAirtableField(index, e.target.value)
	};

	const wordPressFieldChangedHandler = (e) => {
		updateWordPressField(index, e.target.value);
	};

	const customFieldOptionChangedHandler = (e) => {
		updateFieldOption(index, 'name', e.target.value);
	};

	const fieldFormOptionChangedHandler = (formOptionsValues, fieldType, fieldName) => (e) => {
		let value = e.target.value;
		if ('checkbox' === fieldType) {
			value = e.target.checked ? 1 : 0;
		}
		updateFieldOption(index, 'form_options_values', {
			...formOptionsValues,
			[fieldName]: value
		});
	};

	const removeMappingRowHandler = () => {
		removeMappingRow(index)
	};

	const renderCustomFieldOptions = () => {
		return <div className="airwpsync-field form-required">
			<label htmlFor={"customfield_" + airtableField}>
				<span>{__('Custom Field', 'air-wp-sync')}</span>
				<span className="airwpsync-required" aria-hidden="true"> *</span>
				<span className="screen-reader-text">{__(' (required)', 'air-wp-sync')}</span>
			</label>
			<input
				id={"customfield_" + airtableField}
				value={fieldOptions.name ?? ''}
				type="text"
				name={"customfield[" + airtableField + "]"}
				className="regular-text ltr"
				onChange={customFieldOptionChangedHandler}
			/>
		</div>;
	};

	const renderFieldFormOptions = () => {
		return wordPressFieldConfig.form_options.map(function (formOption) {
			const form_option_id = `field_form_option_` + airtableField + '_' + formOption.name;
			const value = fieldOptions.form_options_values && fieldOptions.form_options_values[formOption.name] ? fieldOptions.form_options_values[formOption.name] : '';
			const inputAttributes = {
				id: form_option_id,
				value,
				type: formOption.type,
				name: form_option_id,
				className: 'regular-text ltr',
				onChange: fieldFormOptionChangedHandler(fieldOptions.form_options_values, formOption.type, formOption.name),
			};
			return <div key={form_option_id} className="airwpsync-field">
				<label htmlFor={form_option_id}>
					{
						formOption.type === 'checkbox' ?
							<input
								{...inputAttributes}
								{
								...{
									className: '',
									value: 1,
									style: {
										display: 'inline-block',
										width: '1em',
										verticalAlign: 'middle',
										marginRight: '0.5em',
									},
									checked: !!value
								}
								}
							/>
							: null
					}
					<span>{formOption.label}</span>
				</label>
				{
					formOption.type !== 'checkbox' ?
						<input {...inputAttributes} />
						: null
				}
			</div>;
		})
	}

	return <tr {...props}>
		<td>
			<div className="airwpsync-field form-required">
				<label>
					<span>{__('Airtable Field', 'air-wp-sync')}</span>
					<span className="airwpsync-required" aria-hidden="true">*</span>
					<span className="screen-reader-text">{__(' (required)', 'air-wp-sync')}</span>
				</label>
				<select name="airtable[]" className="regular-text ltr" value={airtableField} disabled={airtableFieldDisabled} onChange={airtableFieldChangedHandler}>
					{
						Object.keys(airtableFieldsOptions).map((groupKey) => {
							const group = airtableFieldsOptions[groupKey];
							return <TranslationsContext.Consumer key={uuidv4()}>{
								({ __ }) => {
									const groupLabel = group.label ?? __('Fields', 'air-wp-sync');
									return <optgroup label={groupLabel}>
										{
											group.options.map((f) => {
												return <option key={uuidv4()} value={f.id}>{f.name}</option>
											})
										}
									</optgroup>
								}
							}</TranslationsContext.Consumer>;
						})
					}
				</select>
			</div>
		</td>
		<td>
			<div className="airwpsync-field form-required">
				<label>
					<span>{__('Import As', 'air-wp-sync')}</span>
					<span className="airwpsync-required" aria-hidden="true">*</span>
					<span className="screen-reader-text">{__(' (required)', 'air-wp-sync')}</span>
				</label>
				<select name="wordpress[]" className="regular-text ltr" value={wordPressField} onChange={wordPressFieldChangedHandler}>
					<option key="default" value=""></option>
					{
						Object.keys(wordPressFieldsOptions[index]).map((groupKey) => {
							const group = wordPressFieldsOptions[index][groupKey];
							return <optgroup key={uuidv4()} label={group.label}>
								{
									group.options.map((option) => {
										return <option key={uuidv4()} value={option.value} disabled={!option.enabled}>{option.label}</option>
									})
								}
							</optgroup>;
						})
					}
				</select>
			</div>
			{wordPressFieldConfig.notice ? <small>{wordPressFieldConfig.notice}</small> : null}
			{wordPressField && wordPressField.split('::')[1] === 'custom_field' ? renderCustomFieldOptions() : null}
			{wordPressFieldConfig.form_options ? renderFieldFormOptions() : null}
		</td>
		<td className="col-actions">
			<div className="btn btn-sort dashicons-before dashicons-menu">
				<span className="screen-reader-text">{__('Sort', 'air-wp-sync')}</span>
			</div>
			<button type="button" className="btn btn-remove" onClick={removeMappingRowHandler}>
				<span className="btn-remove-close-icon" aria-hidden="true">&times;</span>
				<span className="screen-reader-text">{__('Remove', 'air-wp-sync')}</span>
			</button>
		</td>
	</tr>;
}
